// extracted by mini-css-extract-plugin
export default {"scrollHeight":"scrollHeight_Zv7Wi","readOnlyCursor":"readOnlyCursor_WZq_w"};